// Amplify does not always remove every Cognito cookie on signOut; clear them explicitly.
// Writes are host-only (no Domain). Also delete Domain=hostname leftovers from older clients.

import { getClientCookieOptions } from '@/utils/auth/cookieSecurity';
import { clearClientIdTokenCache } from '@/utils/auth/getClientIdToken';
import { deleteCookie, getCookies } from 'cookies-next';

function isAmplifyAuthCookieName(cookieName) {
  const lower = cookieName.toLowerCase();
  return (
    lower.startsWith('cognito') ||
    lower.includes('cognitoidentityserviceprovider')
  );
}

export function resetAmplifyCookies() {
  if (typeof window === 'undefined') {
    return;
  }

  clearClientIdTokenCache();

  const hostname = window.location.hostname;
  const baseOptions = {
    path: '/',
    ...getClientCookieOptions(),
  };

  const cookies = getCookies();
  Object.keys(cookies).forEach((cookieName) => {
    if (!isAmplifyAuthCookieName(cookieName)) {
      return;
    }
    deleteCookie(cookieName, baseOptions);
    if (hostname) {
      deleteCookie(cookieName, { ...baseOptions, domain: hostname });
    }
  });
}
